import React from 'react';
import './style.css';

export const LoadingSpinner = () => {
  return (
    <div className="loading-container">
      <div className="spinner">
        <svg className="spinner-svg" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 50">
          <circle className="spinner-circle" cx="25" cy="25" r="20" fill="none" strokeWidth="5" />
        </svg>
      </div>
    </div>
  );
};
